module.exports = "<ngx-loading [show]=\"loading\" [config]=\"{ backdropBorderRadius: '3px' }\" ></ngx-loading>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/linkedinroute/linkedinroute.component.html
// module id = ./src/app/auth/linkedinroute/linkedinroute.component.html
// module chunks = main